import { gql } from '@apollo/client';

export const DELETE_ATTENDANCE = gql`
  mutation DeleteAttendance($id: Int!) {
    delete_attendance(where: { id: { _eq: $id } }) {
      returning {
        id
      }
    }
  }
`;

export const INSERT_ATTENDANCE = gql`
  mutation InsertAttendance($attendance: [attendance_insert_input!]!) {
    insert_attendance(objects: $attendance) {
      returning {
        gameId
        playerId
        teamId
      }
    }
  }
`;
